import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { ActionIcon, Box, Card, CopyButton, Group, Paper, Text, Tooltip } from '@mantine/core';
export const ProfileReferralCode: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card bg="var(--navbar-bg-color)" radius={5} p={{
    base: 10,
    sm: 20
  }}>
      <Text fz={{
      base: 12,
      sm: 13
    }} fw={700} tt="uppercase" c="var(--text-prime)">
        {i18n._('Referrals code')}
      </Text>
      <Paper px={15} py={6} mt={10} radius={5} bg="linear-gradient(90deg, #303942 0%, #464F59 100%)">
        <Group wrap="nowrap" gap={4} justify="space-between">
          <Box w={{
          base: 300,
          sm: '100%',
          md: 280,
          lg: 300
        }}>
            <Text fz={13} fw={700} c="var(--text-grey-4)" truncate="end">
              {'https//:primeroll.xyz/eioewioewomkiu32998ejmd'}
            </Text>
          </Box>

          <CopyButton value="https//:primeroll.xyz/eioewioewomkiu32998ejmd" timeout={2000}>
            {({
            copied,
            copy
          }) => <Tooltip label={copied ? 'Copied' : 'Copy'} withArrow position="right">
                <ActionIcon color={copied ? 'teal' : 'gray'} variant="subtle" onClick={copy}>
                  {copied ? <Icons className="icon-pr-line-checked" fontSize={24} /> : <Icons className="icon-pr-flat-copy" fontSize={24} />}
                </ActionIcon>
              </Tooltip>}
          </CopyButton>
        </Group>
      </Paper>
    </Card>;
};